import { useState, useCallback } from 'react';
import type { ApiError } from '@/lib/api';

/** Resources a write can conflict on. */
export type ResourceType = 'team' | 'feature' | 'deliverable' | 'simulation';

/** Whether ConflictDialog is open, and for what. */
export interface ConflictState {
  hasConflict: boolean;
  /** The resource whose write was refused */
  resourceType?: ResourceType;
  /** The refusal */
  error?: ApiError;
}

/**
 * State for ConflictDialog: a write was refused because the data changed under
 * it (see `components/form/writeErrors.ts` for which refusals count).
 */
export function useConflictHandler() {
  const [conflictState, setConflictState] = useState<ConflictState>({ hasConflict: false });

  /** Open the dialog for a refused write to `resourceType`. */
  const reportConflict = useCallback((resourceType: ResourceType, error: ApiError) => {
    setConflictState({ hasConflict: true, resourceType, error });
  }, []);

  /** Close the dialog. */
  const clearConflict = useCallback(() => {
    setConflictState({ hasConflict: false });
  }, []);

  return { conflictState, reportConflict, clearConflict };
}
